// extracted by mini-css-extract-plugin
export default {"link":"kB2DkO6X7pa_tff3aGsa","errorText":"_caXxuVOMAoRq0GAL09Q","hideMobile":"tXDDrbYkhznbNOI44ts4","agreement":"DmqYRdwZiarBmTE1j9UU","inlineText":"FVltWSHmIhS1Qzz2CSJx"};